import { I18nManager, DevSettings, Platform } from "react-native"
import * as SplashScreen from "expo-splash-screen"
import * as Updates from "expo-updates"
import * as Sentry from "@sentry/react-native"

import { storage } from "utils/storage"
import "utils/firebase"
import { ENV } from "./utils/env"

// Disable Firebase Analytics as early as possible — before React mounts — so
// the native SDK (Android especially, which has no plist flag and auto-inits at
// app launch) never collects on non-production channels. On iOS the plist
// (`IS_ANALYTICS_ENABLED`) already gates this at build time. Web has no native
// RNFB module — keep the require() lazy so the import is never evaluated there.
if (!__DEV__ && Platform.OS !== "web") {
  const { getAnalytics, setAnalyticsCollectionEnabled } = require("@react-native-firebase/analytics")
  setAnalyticsCollectionEnabled(getAnalytics(), ENV.channel === "production")
}

if (!__DEV__) {
  Sentry.init({
    dsn: "https://db0e697c60ec20f328ec779c1f4e744f@o4510106709000192.ingest.us.sentry.io/4510106769424384",
    release: ENV.version,
    environment: ENV.channel,
    // enable performance monitoring (app start, navigation, slow/frozen frames).
    // v8 auto-registers the React Navigation / expo-router tracing integration
    // once a sample rate is set. Keep production low to stay within quota.
    tracesSampleRate: ENV.channel === "production" ? 0.1 : 0.2,
  })

  Sentry.setTags({ version: ENV.version, channel: ENV.channel, runtimeVersion: ENV.runtimeVersion })
}

SplashScreen.preventAutoHideAsync()

if (Platform.OS !== "web") {
  I18nManager.swapLeftAndRightInRTL(false)
}

I18nManager.allowRTL(true)
I18nManager.forceRTL(true)

if (Platform.OS !== "web" && !I18nManager.isRTL) {
  const numOfReload = storage.getNumber("__numOfReload") ?? 0
  storage.set("__numOfReload", numOfReload + 1)
  if (numOfReload < 2) {
    setTimeout(() => {
      if (__DEV__) DevSettings?.reload()
      else Updates.reloadAsync()
    }, 0)
  }

  storage.set("__numOfReload", 0)
}

import "expo-router/entry"
